import { useRef } from "react";
import { ChangeLayerFunction } from "../extensions/layerManagerExtension";
import { useSubscribeToChangeLayerEvent } from "./event/useChangeLayerEvent";

export function useObjectLayerChangeHandler() {
  const changeLayerFunctionRef = useRef<ChangeLayerFunction>(() => {});

  useSubscribeToChangeLayerEvent((mode) => {
    changeLayerFunctionRef.current(mode);
  });

  const initChangeLayerFunction = (fn: ChangeLayerFunction) => {
    changeLayerFunctionRef.current = fn;
  };

  return {
    initChangeLayerFunction,
  };
}
